/**
 * Ajustes de cuenta corriente (recorrido P3).
 *
 * Es el cargo o abono que no es boleta ni pago: cuota de incorporación,
 * derecho de arranque, deuda traspasada, condonación. El traspaso de derechos
 * los crea solo; estos endpoints son para los casos sueltos.
 */
import { apiRequest } from "../../lib/api";

export type TipoAjuste = "Cargo" | "Abono";

export type ConceptoAjuste =
  | "CuotaIncorporacion"
  | "DerechoArranque"
  | "TraspasoDeuda"
  | "Condonacion"
  | "Otro";

export interface AjusteRead {
  id: number;
  socio_id: number;
  contrato_id: number | null;
  tipo: TipoAjuste;
  concepto: ConceptoAjuste;
  etiqueta: string;
  monto: number;
  motivo: string;
  observacion: string | null;
  fecha: string;
  /** Boleta que lo cobró. null = todavía no facturado. */
  lectura_id: number | null;
  estado: string;
  /** Cuánto suma (+) o resta (−) al saldo del socio hoy. */
  efecto_en_saldo: number;
  motivo_anulacion: string | null;
  created_at: string;
}

export interface AjusteCreate {
  socio_id: number;
  tipo: TipoAjuste;
  concepto: ConceptoAjuste;
  monto: number;
  motivo: string;
  contrato_id?: number | null;
  observacion?: string | null;
  fecha?: string | null;
}

export function listarAjustes(
  socioId?: number,
  incluirAnulados = false,
): Promise<AjusteRead[]> {
  const q = new URLSearchParams();
  if (socioId !== undefined) q.set("socio_id", String(socioId));
  if (incluirAnulados) q.set("incluir_anulados", "true");
  const qs = q.toString();
  return apiRequest<AjusteRead[]>(`/api/v1/ajustes${qs ? `?${qs}` : ""}`);
}

export function crearAjuste(p: AjusteCreate): Promise<AjusteRead> {
  return apiRequest<AjusteRead>("/api/v1/ajustes", { method: "POST", body: p });
}

export function anularAjuste(
  id: number,
  motivo: string,
): Promise<AjusteRead> {
  return apiRequest<AjusteRead>(`/api/v1/ajustes/${id}/anular`, {
    method: "POST",
    body: { motivo },
  });
}
